import { Text } from "@fluentui/react";
import { makeStyles, } from "@fluentui/react-components";
import { useState } from "react";
import { ActionButton } from "@fluentui/react/lib/Button";
import { useNavigate } from "react-router-dom";

class Properties {
  list: any;
  valueWidth?: string;
}

const useStyles = makeStyles({
  row: {
    display: 'flex',
  },
  label: {
    width: '200px',
    fontWeight: 'bold',
  },
  value: {
  },
});

export default function InfoList(properties: Properties) {
  const styles = useStyles();
  const navigate = useNavigate();

  return (
    <div>
      {properties.list.map((item: any) => <div className="displayFlex alignItemsCenter">
        <div className={styles.label}><Text variant="medium" style={{ fontWeight: 'bold' }}>{item.label}:</Text></div>
        {item.link
          ?
          <div style={{ width: item.valueWidth || properties.valueWidth || '200px', display: 'flex', justifyContent: item.align && item.align === 'right' ? 'flex-end' : 'flex-start' }}><a href={item.link} target="_blank" rel="noopener noreferrer"><Text variant="medium" style={{ color: item.color }}>{item.value} {item.suffix}</Text></a></div>
          :
          <div className="displayFlex alignItemsCenter gapS" style={{ width: item.valueWidth || properties.valueWidth || '200px', justifyContent: item.align && item.align === 'right' ? 'flex-end' : 'flex-start' }}><Text variant="medium" style={{ color: item.color }}>{item.value} {item.suffix}</Text>
            {item.navigationLink
              ?
              <ActionButton className='marginTopS' iconProps={{ iconName: 'OpenInNewWindow' }} onClick={() => {
                navigate(item.navigationLink);
              }}></ActionButton>
              :
              <></>
            }
          </div>}
      </div>)}
    </div>
  );
}
